export function addTogglePrevNextBtnsActive( embla_api, prev_btn, next_btn ) {
	const toggle_prev_next_btns_state = () => {
		if ( embla_api.canScrollPrev() ) {
			prev_btn.removeAttribute( 'disabled' );
		} else {
			prev_btn.setAttribute( 'disabled', 'disabled' );
		}

		if ( embla_api.canScrollNext() ) {
			next_btn.removeAttribute( 'disabled' );
		} else {
			next_btn.setAttribute( 'disabled', 'disabled' );
		}
	};

	embla_api
		.on( 'select', toggle_prev_next_btns_state )
		.on( 'init', toggle_prev_next_btns_state )
		.on( 'reInit', toggle_prev_next_btns_state );

	return () => {
		prev_btn.removeAttribute( 'disabled' );
		next_btn.setAttribute( 'disabled', 'disabled' );
	};
}

export function addPrevNextBtnsClickHandlers( embla_api, prev_btn, next_btn ) {
	const scroll_prev = () => embla_api.scrollPrev();
	const scroll_next = () => embla_api.scrollNext();
	prev_btn.addEventListener( 'click', scroll_prev, false );
	next_btn.addEventListener( 'click', scroll_next, false );

	return () => {
		prev_btn.removeEventListener( 'click', scroll_prev, false );
		next_btn.removeEventListener( 'click', scroll_next, false );
	};
}

export const add_dot_btns_and_click_handlers = ( embla_api, dots_node ) => {
	let dot_nodes = [];

	const add_dot_btns_with_click_handlers = () => {
		dots_node.innerHTML = embla_api
			.scrollSnapList()
			.map( ( el, index ) => '<button class="carousel__pip" type="button">' + ( index + 1 ) + '</button>' )
			.join( '' );

		const scroll_to = ( index ) => {
			embla_api.scrollTo( index );
		};

		dot_nodes = Array.from( dots_node.querySelectorAll( '.carousel__pip' ) );
		dot_nodes.forEach( ( dot_node, index ) => {
			dot_node.addEventListener( 'click', () => scroll_to( index ), false );
		} );
	};

	const toggle_dot_btns_active = () => {
		const previous = embla_api.previousScrollSnap();
		const selected = embla_api.selectedScrollSnap();
		dot_nodes[previous].classList.remove( 'carousel__pip--selected' );
		dot_nodes[selected].classList.add( 'carousel__pip--selected' );
	};

	embla_api
		.on( 'init', add_dot_btns_with_click_handlers )
		.on( 'reInit', add_dot_btns_with_click_handlers )
		.on( 'init', toggle_dot_btns_active )
		.on( 'reInit', toggle_dot_btns_active )
		.on( 'select', toggle_dot_btns_active );

	return () => {
		dots_node.innerHTML = '';
	};
};


export function getWindowHeight() {
	return ( window.innerHeight || document.documentElement.clientHeight );
}

export function getWindowWidth() {
	return ( window.innerWidth || document.documentElement.clientWidth );
}
